module.exports = __webpack_public_path__ + "img/visuel_deconnexion.080ffd16.svg";